export const defaultSections = [
  {
    id: 1,
    title: "சுயவிவர குறிப்புகள்",
    fields: [
      { id: 1, label: "ಹೆಸರು", value: "ಹೆಸರು ನಮೂದಿಸು" },
      { id: 2, label: "ಜನ್ಮ ದಿನಾಂಕ", value: "ಜನ್ಮ ನಮೂದಿಸು" },
      { id: 3, label: "ಜನ್ಮ ಸ್ಥಳ", value: "ಜನ್ಮ ಸ್ಥಳ ನಮೂದಿಸು" },
      { id: 4, label: "ವೃತ್ತಿ", value: "ವೃತ್ತಿ ನಮೂದಿಸು" },
      { id: 5, label: "ಆದಾಯ", value: "ಆದಾಯ ನಮೂದಿಸು" },
      { id: 6, label: "ಶಿಕ್ಷಣ", value: "ಶಿಕ್ಷಣ ನಮೂದಿಸು" },
      { id: 7, label: "ಎತ್ತರ", value: "ಎತ್ತರ ನಮೂದಿಸು" }
    ]
  },
  {
    id: 2,
    title: "குடும்ப விவரங்கள்",
    fields: [
      { id: 8, label: "ತಂದೆಯ ಹೆಸರು", value: "ತಂದೆಯ ಹೆಸರು ನಮೂದಿಸು" },
      { id: 9, label: "ತಂದೆ ವೃತ್ತಿ", value: "ತಂದೆಯ ವೃತ್ತಿ ನಮೂದಿಸು" },
      { id: 10, label: "ತಾಯಿಯ ಹೆಸರು", value: "ತಾಯಿಯ ಹೆಸರು ನಮೂದಿಸು" },
      { id: 11, label: "ತಾಯಿಯ ವೃತ್ತ", value: "ತಾಯಿಯ ವೃತ್ತಿ ನಮೂದಿಸು" }
    ]
  },
  {
    id: 3,
    title: "தொடர்பு விவரங்கள்",
    fields: [
      { id: 12, label: "ಸಂಪರ್ಕಿಸಬೇಕಾದ ವ್ಯಕ್ತ", value: "ಸಂಪರ್ಕಿಸಬೇಕಾದ ವ್ಯಕ್ತಿ ನಮೂದಿಸು" },
      { id: 13, label: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ", value: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ ನಮೂದಿಸು" },
      { id: 14, label: "ವಾಸಸ್ಥಳ ವಿಳಾಸ", value: "ವಾಸಸ್ಥಳ ವಿಳಾಸ ನಮೂದಿಸು" }
    ]
  }
];




